import { lazyPage } from '../../utils/lazyPage';

const NCAAFBestPicksToday = lazyPage(() => import('./BestPicksToday'));
const NCAAFmoneyline = lazyPage(() => import('./NCAAFmoneyline/NCAAFmoneyline'));
const NCAAFspread = lazyPage(() => import('./NCAAFspread/NCAAFspread'));
const NCAAFtotal = lazyPage(() => import('./NCAAFtotal/NCAAFtotal'));

const ncaafRoutes = [
  {
    path: '/ncaaf/best-picks-today',
    label: 'Best Edges Today',
    renderer: (params = {}) => <NCAAFBestPicksToday {...params} />,
    hidden: true
  },
  {
    path: '/ncaaf/moneyline',
    label: 'Moneylines',
    renderer: (params = {}) => <NCAAFmoneyline {...params} />
  },
  {
    path: '/ncaaf/spread',
    label: 'Spreads',
    renderer: (params = {}) => <NCAAFspread {...params} />
  },
  {
    path: '/ncaaf/total',
    label: 'Totals',
    renderer: (params = {}) => <NCAAFtotal {...params} />
  }
];

export default ncaafRoutes;
